"use client";

import React from "react";
import { CompanyQuickBooksPanel } from "./CompanyQuickBooksPanel";
import type { CompanyEntity } from "@/lib/types/company";

interface CompanyQuickBooksTabProps {
  company: CompanyEntity;
}

export const CompanyQuickBooksTab: React.FC<CompanyQuickBooksTabProps> = ({ company }) => (
  <CompanyQuickBooksPanel companyId={company.id} companyDisplayName={company.name} />
);
